<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="bk-title">The Wrong Box</p>
<p class="authorname">Robert Louis Stevenson and Lloyd Osbourne</p>
<p class="publisher"><span><img alt="logo1" class="svg" src="Book1/image/fig_logo.jpg"/></span></p>
<p class="publisher1"><span><a href="http://MYSTERIOUSPRESS.COM" target="_blank">MYSTERIOUSPRESS.COM</a></span></p>
<p class="publisher1"><span><img alt="logo" class="svg" src="Book1/image/logo.jpg"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1.vue?e0b6526a